import React from'react';

const languages = ["eu", "es", "en"];
const languagePreference = "eu";
const surveyToView = "Astigarraga"
const startTraductions = {"eu":"hasi", "es":"entra", "en":"start"}
const nextTraductions = {"eu":"hurrengoa", "es":"siguiente", "en":"next"}
const previousTraductions = {"eu":"aurrekoa", "es":"anterior", "en":"previous"}
const submitTraductions = {"eu":"bidali", "es":"enviar", "en":"submit"}
const confirmTraductions = {"eu":"Konfirmatu", "es":"Confirmar", "en":"Confirm"}
const helloMsgTranslate1 = {"eu":"Astigarragako mugikortasun ohiturak aztertzen ari gara.", 
                        "es":"Estamos analizando los hábitos de movilidad de Astigarraga.",
                        "en":"We are analyzing mobility habits in Astigarraga."}
const helloMsgTranslate2 = {"eu":"Erantzungo zenieke, mesedez, ondorengo galderei? Anonimoa da eta bi minutu baino gutxiago izango dira. Mila esker!", 
                        "es":"¿Podrías responder al siguiente cuestionario, por favor? Es anónimo y tardarás menos de dos minutos. ¡Gracias!",
                        "en":"Could you answer the following questions, please? It's anonymous and it will take you less than two minutes. Thank you! "}
const goodbyMsgTranslate = {"eu":<>
                              <div className="horCentered leaveMidSpace">Iconos diseñados por <a href='https://www.flaticon.es/autores/freepik' 
                              title='Freepik'>Freepik</a> de <a href='https://www.flaticon.es/' title='Flaticon'>www.flaticon.es</a></div></>, 
                        "es":<>
                              <div className="horCentered leaveMidSpace">Iconos diseñados por <a href='https://www.flaticon.es/autores/freepik' 
                              title='Freepik'>Freepik</a> from <a href='https://www.flaticon.es/' title='Flaticon'>www.flaticon.es</a></div></>,
                        "en":<>
                              <div className="horCentered leaveMidSpace">Icons designed by <a href='https://www.flaticon.es/autores/freepik' 
                              title='Freepik'>Freepik</a> from <a href='https://www.flaticon.es/' title='Flaticon'>www.flaticon.es</a></div></>}
const emailMsgTranslate = {"eu":"Si quieres que te informemos sobre los resultados una vez acabadas y analizadas la encuestas, déjanos tu email.", 
                        "es":"Si quieres que te informemos sobre los resultados una vez acabadas y analizadas la encuestas, déjanos tu email.",
                        "en":"If you want us to send you information about the results once we have analized the survey, please leave your email below."}
const emailTranslate = {"eu":"zure emaila", "es":"tu email", "en":"your email"}
const sendMsgTranslate = {"eu":"Ia prest! Mesedez, ez ahaztu erantzunak bidaltzeaz.", 
                        "es":"¡Casi listo! Por favor, no te olvides de enviar tus respuestas.",
                        "en":"Almost done! Please don't forget to send your answers."}
const searchTranslate = {"eu":"Bilatu mapan", "es":"Buscar en el mapa", "en":"Search places"}//{"eu":"Bilatu mapan", "es":"Buscar en el mapa", "en":"Search places"}

function languageFilter(texts, language)
{
    if(texts instanceof Object)
        return(texts[language])
    else
        return texts

}
export default {
  languages,
  helloMsgTranslate1,
  helloMsgTranslate2,
  goodbyMsgTranslate,
  languagePreference,
  surveyToView,
  startTraductions,
  nextTraductions,
  previousTraductions,
  submitTraductions,
  confirmTraductions,
  languageFilter,
  emailMsgTranslate,
  emailTranslate,
  sendMsgTranslate,
  searchTranslate
};
